import { daysAgo } from 'shared/time';

export function determineIsNew(first_listed_at?: string | null) {
  if (!first_listed_at) return false;

  const firstListedAt = new Date(first_listed_at);

  return daysAgo(firstListedAt) <= 30;
}
